/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AgeListAgeRequest } from '../models/AgeListAgeRequest';
import type { AgeListAgeResponseApiRespoonse } from '../models/AgeListAgeResponseApiRespoonse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AgeManagerService {

    /**
     * Get list live images
     * @param requestBody
     * @returns AgeListAgeResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminAge(
        requestBody: AgeListAgeRequest,
    ): CancelablePromise<AgeListAgeResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/age',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

}
